<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">
    <span *ngIf="data.type !== 3">{{ 'deleteModal.title' | translate }}</span>
    <span *ngIf="data.type === 3">{{ 'deleteModal.titleFolder' | translate }}</span>
  </h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden px-6">
  <div>
    <div *ngIf="data.type !== 3">{{ 'deleteModal.text' | translate }}</div>
    <div *ngIf="data.type === 3">{{ 'deleteModal.textFolder' | translate }}</div>
  </div>
  <mat-checkbox *ngIf="data.logic" [(ngModel)]="checked" color="primary" class="mt-2">
    <span *ngIf="data.type !== 3">{{ 'deleteModal.yes' | translate }}</span>
    <span *ngIf="data.type === 3">{{ 'deleteModal.confirmationFolder' | translate }}</span>
  </mat-checkbox>
</mat-dialog-content>

<div *ngIf="data.logic" mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" [mat-dialog-close]="true">{{'global.cancel' | translate}}</flow-button>
  <flow-button theme="danger" [disabled]="!checked" (onClick)="onConfirm()">{{'global.delete' | translate}}</flow-button>
</div>
